function TenantLocationCtrl($stateParams, TenantsService, LocationsService, $state, sweet, ProgressBarService, ToastsService) {
  "ngInject";

  let vm = this;
  vm.location = {
    key: undefined
  };
  vm.tenantId = $stateParams.tenantId;
  vm.editMode = !!$stateParams.locationId;
  if (vm.editMode) {
    let locationPromise = LocationsService.getLocationById($stateParams.locationId);
    locationPromise.then(function (data) {
      vm.location = data;
      vm.tenantId = data.tenantId || data.tenant.id;
      vm.locationName = data.customerLocationName;
      vm.fetchTenantName(vm.tenantId);
    }).catch((err) => {
      console.log(err)
      ToastsService.showErrorToast('Something went wrong.');
    });
  }

  vm.initialize = function () {
    if (!vm.editMode) {
      vm.fetchTenantName(vm.tenantId);
      return vm.location = {
        tenantId: vm.tenantId,
        active: true
      };
    }
  };

  vm.onClickSaveButton = function () {
    ProgressBarService.start();
    let promise = LocationsService.save(vm.location);
    if (vm.editMode) {
      return promise.then(vm.onSuccessUpdatingLocation(vm.tenantId), vm.onFailureSavingLocation);
    } else {
      return promise.then(vm.onSuccessSavingLocation, vm.onFailureSavingLocation);
    }
  };

  vm.onSuccessSavingLocation = function () {
    ProgressBarService.complete();
    ToastsService.showSuccessToast('We saved your location.');
    return setTimeout((function () {
      $state.go('main.tenantLocations', {tenantId: $stateParams.tenantId});
      return;
    }), 1000);
  };

  vm.onSuccessUpdatingLocation = function (tenant_key) {
    ProgressBarService.complete();
    ToastsService.showSuccessToast('We updated your location.');
    return setTimeout((function () {
      $state.go('main.tenantLocations', {tenantId: tenant_key});
      return;
    }), 1000);
  };

  vm.onFailureSavingLocation = function (response) {
    ProgressBarService.complete();
    if (response.status === 409) {
      ToastsService.showErrorToast('Location code conflict. Unable to save your location.');
      return sweet.show('Oops...',
        'Please change your customer location name. Location name must generate a unique location code.',
        'error');
    } else {
      return ToastsService.showErrorToast('Unable to save your location.');
    }
  };

  vm.fetchTenantName = function (tenantId) {
    let tenantPromise = TenantsService.getTenantById(tenantId);
    tenantPromise.then(tenant => {
      vm.tenantName = tenant.name
    }).catch((err) => {
      console.log(err)
      ToastsService.showErrorToast('Something went wrong.');
    })
  };

  vm.autoGenerateCustomerLocationCode = function () {
    if (!vm.location.key) {
      let newCustomerLocationCode = '';
      if (vm.location.customerLocationName) {
        newCustomerLocationCode = vm.location.customerLocationName.toLowerCase();
        newCustomerLocationCode = newCustomerLocationCode.replace(/\s+/g, '_');
        newCustomerLocationCode = newCustomerLocationCode.replace(/\W+/g, '');
      }
      return vm.location.customerLocationCode = newCustomerLocationCode;
    }
  };

  return vm;
}
export {TenantLocationCtrl}
